import Navbar from '../components/navbar/navbar';
import About from "../components/about/about";
import HeroBanner from "../components/hero-banner/hero-banner";
import Intro from "../components/intro/intro";
import Skills from "../components/skills/skills";
import Projects from '../components/projects/projects';
import ContactsIntro from '../components/contacts-intro/contacts-intro';

const Home: React.FC = () => {
  return (
    <>
        <Navbar/>
        <HeroBanner/>
        <Intro/>
        <About/>
        <Skills/>
        <Projects/>
        <ContactsIntro/>
    </>
  );
};

export default Home;